import { useEffect } from 'react';

import useProjectInfo from 'hooks/useProjectInfo';
import { TrackingService } from '../../services/Tracking';

// Estendi l'interfaccia Window per includere dataLayer
declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

export const DATADOG_CONFIG = {
  applicationId: '87245586-32ce-4082-b271-0a19aeb4bdcc',
  clientToken: 'pub5ecc72957a3e7399060e36a85d2ced5c',
  site: 'datadoghq.eu',
  service: 'myaccount',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: 'mask-user-input' as const,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
} as const;

const Tracking = () => {
  const projectInfo = useProjectInfo();

  useEffect(() => {
    TrackingService.getInstance().initializeTracking();

    if (!projectInfo.data?.GTMCode) return;

    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    // Carica il GTM di Homizy
    const script = document.createElement('script');
    script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${projectInfo.data.GTMCode}');
      `;
    document.head.appendChild(script);

    // Aggiungi il noscript per GTM di Homizy
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${projectInfo.data.GTMCode}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.appendChild(noscript);
  }, [projectInfo.data]);

  // Questo componente non renderizza nulla
  return null;
};

export default Tracking;
